// A time zone's country, for the flag the banner shows beside dates moved to the viewer's
// calendar (Seán, 2026-10-22: a flag, not "Sydney local time"). Only the zones where an evening
// in London is already the next day (UTC+7 and east in November) are listed: elsewhere the dates
// don't move, so no flag is needed. A zone not listed gets no flag (the text stays).

const COUNTRY_BY_CITY = {
  AU: "Adelaide Brisbane Broken_Hill Darwin Eucla Hobart Lindeman Lord_Howe Melbourne Perth "
    + "Sydney Canberra ACT NSW Queensland Victoria Tasmania West North South",
  BN: "Brunei", CN: "Shanghai Chongqing Chungking Harbin Urumqi", FJ: "Fiji", FM: "Kosrae "
    + "Ponape Pohnpei Truk Chuuk", GU: "Guam", HK: "Hong_Kong", ID: "Jakarta Jayapura Makassar "
    + "Pontianak", JP: "Tokyo", KH: "Phnom_Penh", KI: "Enderbury Kanton Kiritimati Tarawa",
  KP: "Pyongyang", KR: "Seoul", LA: "Vientiane", MH: "Kwajalein Majuro", MN: "Hovd Ulaanbaatar "
    + "Ulan_Bator Choibalsan", MO: "Macau", MP: "Saipan", MY: "Kuala_Lumpur Kuching", NC: "Noumea",
  NF: "Norfolk", NR: "Nauru", NZ: "Auckland Chatham", PG: "Port_Moresby Bougainville",
  PH: "Manila", PW: "Palau", RU: "Anadyr Barnaul Chita Irkutsk Kamchatka Khandyga Krasnoyarsk "
    + "Magadan Novokuznetsk Novosibirsk Sakhalin Srednekolymsk Tomsk Ust-Nera Vladivostok Yakutsk",
  SB: "Guadalcanal", SG: "Singapore", TH: "Bangkok", TK: "Fakaofo", TL: "Dili", TO: "Tongatapu",
  TV: "Funafuti", TW: "Taipei", UM: "Wake", VN: "Saigon Ho_Chi_Minh", VU: "Efate", WF: "Wallis",
  WS: "Apia", CX: "Christmas",
};

const COUNTRY_BY_ZONE_CITY = new Map(Object.entries(COUNTRY_BY_CITY).flatMap(([code, cities]) => {
  return cities.split(" ").map((city) => [city, code]);
}));

// "Australia/Sydney" → "AU"; "" when not listed (Antarctica's stations too)
export function getZoneCountry(zone) {
  const [region, city] = String(zone || "").split("/");
  if (!city || region === "Antarctica") return "";
  return COUNTRY_BY_ZONE_CITY.get(city) || "";
}

// "AU" → 🇦🇺 (the two regional-indicator letters; Windows shows them as letters)
export function getFlagEmoji(code) {
  if (!/^[A-Z]{2}$/.test(code)) return "";
  return String.fromCodePoint(...[...code].map((letter) => 0x1f1a5 + letter.charCodeAt(0)));
}
